import clsx from "clsx";
import { useId, type TextareaHTMLAttributes } from "react";

interface TextAreaProps extends TextareaHTMLAttributes<HTMLTextAreaElement> {
  /** The question or name in words, shown above the box. */
  label: string;
  hint?: string;
  /** Why the box was refused, in plain words. */
  error?: string | null;
}

/** A labelled box for a few sentences. Same look and wiring as `TextField`. */
export function TextArea({ label, hint, error, id, className, rows = 4, ...rest }: TextAreaProps) {
  const auto = useId();
  const areaId = id ?? auto;
  const hintId = `${areaId}-hint`;
  const errorId = `${areaId}-error`;
  const describedBy = [hint ? hintId : null, error ? errorId : null].filter(Boolean).join(" ") || undefined;
  return (
    <div className={clsx("field", className)}>
      <label htmlFor={areaId} className="field__label">
        {label}
      </label>
      {hint && (
        <p id={hintId} className="field__hint muted">
          {hint}
        </p>
      )}
      <textarea id={areaId} className="field__input ra-textarea" rows={rows} aria-describedby={describedBy} aria-invalid={error ? true : undefined} {...rest} />
      {error && (
        <p id={errorId} role="alert" className="field__error">
          {error}
        </p>
      )}
    </div>
  );
}
